<template>
  <a-locale-provider :locale="locale">
    <div :class="{'l8-cart': true, 'open': open}" v-if="ready">
      <div class="cart-mask" v-if="open" @click="open = false"></div>
      <a-affix class="cart-affix" :offsetTop="0">
        <div class="container">
          <div class="cart-info clearfix">
            <h3>订单详情</h3>
            <div class="itinerarys">
              <table>
                <tr v-for="(offer, index) in flights" :key="index">
                  <td class="vertical-align-top" v-show="mutiple">行程{{ index + 1 }}:</td>
                  <td v-for="(transferItem, transferIndex) in offer.itinerarys?.[0]?.orgDsts" :key="transferIndex">
                    <itinerary-total :orgDst="transferItem"></itinerary-total>
                  </td>
                </tr>
              </table>
            </div>
            <div class="passengers">
              <l8-icon class="l8-icon" type="icon-user"/>
              {{ passengerInfo | passengers }}
            </div>
            <div class="open" v-if="!open" @click="open = true"><span>更多详情</span><l8-icon class="l8-icon" type="icon-xiajiantou"/></div>
            <div class="close" v-else @click="open = false"><l8-icon class="l8-icon" type="icon-chahao1"/></div>
            <div class="total">
              {{ totalFare }}元
            </div>
          </div>
          <div class="cart-detail" v-show="open">
            <a-row class="cart-detail-wrapper">
              <a-col class="itinerarys" :md="12" :sm="24" :xs="24">
                <h4><l8-icon class="l8-icon" type="icon-feiji1"/>航班信息</h4>
                <dl class="itinerary" v-for="(offer, offerIndex) in flights" :key="offerIndex">
                  <dt v-show="mutiple">行程{{ offerIndex + 1 }}:</dt>
                  <dd v-for="(transferItem, transferIndex) in offer.itinerarys?.[0]?.orgDsts" :key="transferIndex">
                    <itinerary-detail :orgDst="transferItem" :serviceClass="offer.ticketCartItems?.[transferIndex]?.detail?.productDetailDTO?.serviceClass"></itinerary-detail>
                    <!-- 中转标识 -->
                    <a-divider class="transfer-label" orientation="center" v-if="transferIndex < offer.itinerarys[0].orgDsts.length - 1" :key="transferIndex"> 中转 </a-divider>
                  </dd>
                </dl>
              </a-col>

              <a-col class="products" :md="12" :sm="24" :xs="24">
                <h4><l8-icon class="l8-icon" type="icon-user"/>订单金额</h4>
                <!-- 国内 -->
                <template v-if="!ifInternational">
                  <!-- 直达 -->
                  <template v-if="!isCT">
                    <dl class="cart-item" v-for="(offer, index) in flights" :key="index">
                      <dt v-show="mutiple">行程{{ index + 1 }}:</dt>
                      <dl v-for="(transferItem, transferIndex) in offer.itinerarys?.[0]?.orgDsts" :key="transferIndex">
                        <template v-for="item in offer.ticketCartItems[0].detail.passengerPrices">
                          <dd v-if="item.count !== '0'" :key="item.passengerType">
                            <span class="label">
                              {{ item.passengerType | passengerType }} x{{ item.count }}
                              <change-rule
                                :type="item.passengerType"
                                :isJJC="isJJC"
                                :rules="transferItem.refundChangeFees"
                                :cmsData="cmsData"
                                :ifInternational="ifInternational"
                              ></change-rule>
                            </span>
                            <span class="value">￥{{ item.totalFare }}</span>
                            <span class="value delete-line" v-if="item.totalOrgNetFare">￥{{ item.totalOrgNetFare }}</span>
                          </dd>
                        </template>
                        <dd v-for="item in offer.ticketCartItems[0].detail.taxs" :key="item.code">
                          <span class="label">{{ item.name }}</span>
                          <span class="value">￥{{ item.amount }}</span>
                        </dd>
                        <dd v-if="offer.ticketCartItems[0].detail.deductible">
                          <span class="label">机票优惠券</span>
                          <span class="value">￥ -{{ offer.ticketCartItems[0].detail | couponAmount }}</span>
                        </dd>
                        <template v-for="item in offer?.ancillaryCartItems" >
                          <template v-for="detailItem in item?.detail">
                            <dd :key="detailItem.offerItemId">
                              <span class="label">{{ detailItem | product(item) }} x{{ detailItem.passengerPrices[0].count }}</span>
                              <span class="value">￥{{ detailItem.passengerPrices[0].totalFare }}</span>
                            </dd>
                          </template>
                        </template>
                        <dd v-for="item in offer.couponCartItems" :key="item.detail.couponNumber">
                          <span class="label">{{ item | product }} x{{ item.detail.passengerPrices[0].count }}</span>
                          <span class="value">￥{{ item.detail.passengerPrices[0].totalFare }}</span>
                        </dd>
                      </dl>
                    </dl>
                  </template>
                  <!-- 中转联程 -->
                  <template v-else>
                    <dl class="cart-item" v-for="(offer, index) in flights" :key="index">
                      <dt v-show="mutiple">行程{{ index + 1 }}:</dt>
                      <dl v-for="(ticketCartItem, ticketCartIndex) in offer.ticketCartItems" :key="ticketCartItem.detail.offerItemId">
                        <template v-for="item in ticketCartItem.detail.passengerPrices">
                          <dd v-if="item.count !== '0'" :key="item.passengerType">
                            <span class="label">
                              {{ item.passengerType | passengerType }} x{{ item.count }}
                              <change-rule
                                :type="item.passengerType"
                                :isJJC="isJJC"
                                :rules="offer.itinerarys?.[0]?.orgDsts[ticketCartIndex].refundChangeFees"
                                :cmsData="cmsData"
                                :ifInternational="ifInternational"
                              ></change-rule>
                            </span>
                            <span class="value">￥{{ item.totalFare }}</span>
                            <span class="value delete-line" v-if="item.totalOrgNetFare">￥{{ item.totalOrgNetFare }}</span>
                          </dd>
                        </template>
                        <dd v-for="item in ticketCartItem.detail.taxs" :key="item.name">
                          <span class="label">{{ item.name }}</span>
                          <span class="value">￥{{ item.amount }}</span>
                        </dd>
                        <dd v-if="ticketCartItem.detail.deductible">
                          <span class="label">机票优惠券</span>
                          <span class="value">￥ -{{ offer.ticketCartItems[0].detail | couponAmount }}</span>
                        </dd>
                        <template v-for="item in offer?.ancillaryCartItems" >
                          <template v-for="detailItem in item?.detail">
                            <dd :key="detailItem.offerItemId">
                              <span class="label">{{ detailItem | product(item) }} x{{ detailItem.passengerPrices[0].count }}</span>
                              <span class="value">￥{{ detailItem.passengerPrices[0].totalFare }}</span>
                            </dd>
                          </template>
                        </template>
                        <dd v-for="item in offer.couponCartItems" :key="item.detail.couponNumber">
                          <span class="label">{{ item | product }} x{{ item.detail.passengerPrices[0].count }}</span>
                          <span class="value">￥{{ item.detail.passengerPrices[0].totalFare }}</span>
                        </dd>
                      </dl>
                    </dl>
                  </template>
                </template>
                <!-- 国际 -->
                <template v-else>
                  <dl>
                    <template v-for="item in cart.passengerPrices">
                      <dd v-if="item.count !== '0'" :key="item.passengerType">
                        <span class="label">
                          {{ item.passengerType | passengerType }} x{{ item.count }}
                        </span>
                        <span class="value">￥{{ item.totalFare }}</span>
                        <span class="value delete-line" v-if="item.totalOrgNetFare">￥{{ item.totalOrgNetFare }}</span>
                      </dd>
                    </template>
                    <dd v-for="item in cart.taxs" :key="item.code">
                      <span class="label"> {{ item.type | passengerType }} {{ item.name }}</span>
                      <span class="value">￥{{ item.amount }}</span>
                    </dd>
                    <!-- TODO: 辅营 -->
                    <template v-for="(offer) in flights" >
                      <template v-for="item in offer?.ancillaryCartItems" >
                        <template v-for="detailItem in item?.detail">
                          <dd :key="detailItem.offerItemId" >
                            <span class="label">{{ detailItem | product(item) }} x{{ detailItem.passengerPrices[0].count }}</span>
                            <span class="value">￥{{ detailItem.passengerPrices[0].totalFare }}</span>
                          </dd>
                        </template>
                      </template>
                    </template>
                  </dl>
                </template>
                <template v-if="cart.cardCoupons?.length > 0">
                  <dl class="cart-item">
                    <dt>卡券</dt>
                    <dl v-for="cardCoupon in cart.cardCoupons" :key="cardCoupon.couponCode">
                      <dd>
                        <span class="label">{{ cardCoupon.name }}</span>
                        <span class="value">￥ -{{ cardCoupon.couponAmount }}</span>
                      </dd>
                    </dl>
                  </dl>
                </template>
              </a-col>
            </a-row>

            <div class="total" :span="24">
              总额：<span class="value">{{ totalFare }}元</span>
            </div>
          </div>
        </div>
      </a-affix>
    </div>
  </a-locale-provider>
</template>

<script>
import { findIndex, isEmpty, get } from 'lodash'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import ChangeRule from './Rule.vue'
import ItineraryDetail from './itinerary-detail.vue'
import ItineraryTotal from './itinerary-total.vue'

export default {
  name: 'l8-cart',
  props: {
    id: [String, Number],
    value: Object,
    isJJC: {
      type: Boolean,
      default: function () {
        return false
      }
    }
  },
  data () {
    return {
      cartId: '',
      cart: {},
      flights: [],
      totalFare: 0,
      open: false,
      ready: false,
      locale: zhCN,
      cmsData: {},
      passengerInfo: [],
      ifInternational: false,
      isCT: false
    }
  },
  computed: {
    mutiple () {
      return this.flights.length > 1
    }
  },
  watch: {
    value (newValue) {
      this.setValue(newValue)
    },
    open: {
      handler: (value) => {
        if (value) {
          window.__MICRO_ROOT__?.api?.track?.('reserve_passenger_priceclick')
        }
      }
    }
  },
  created () {
    const { value } = this
    this.setValue(value)
    this.getCmsData()
  },
  methods: {
    setValue (value) {
      if (!isEmpty(value)) {
        this.cartId = value.shoppingCartId
        this.totalFare = value.totalFare - 0
        this.cart = value
        this.isCT = Boolean(value.offers.find(offer => {
          return offer.detail.itinerarys.find(itinerary => {
            return itinerary.itineraryType === 'CT'
          })
        }))
        this.ifInternational = value.ifInternational
        this.passengerInfo = (!value.ifInternational ? get(value, 'offers[0].detail.ticketCartItems[0].detail.passengerPrices') : value.passengerPrices) || []

        const flights = []
        value.offers.forEach(offer => {
          if (offer.type === 'Flight') {
            flights.push(offer.detail)
          }
        })

        this.flights = flights
        this.ready = !!flights.length
      }
    },
    // 新增支持辅营产品及优惠券
    // product = { offerItemType: '', detail: { "offerItemId": "111112", "productCode": "YXRS", "productName": "鱼香肉丝饭", "price": 30, "count": 1 } }
    // cart = { offerItemType: 'COUPON', detail: { productName: '优惠券', price: -'', count: 1, couponType: '', couponNumber: '' } }
    add (product, index, type = 'ancillary') {
      const { flights } = this
      const ancillaries = type === 'coupon'
        ? (flights[index].couponCartItems || [])
        : (flights[index].ancillaryCartItems || [])
      const idx = type === 'coupon'
        ? (findIndex(ancillaries, item => item.detail.couponType === product.detail.couponType))
        : (findIndex(ancillaries, item => item.detail.offerItemId === product.detail.offerItemId))
      if (idx > -1) {
        const ancillary = ancillaries[idx]
        const detail = ancillary.detail.passengerPrices[0]
        const total = product.detail.count * product.detail.price
        detail.count += product.detail.count
        detail.totalFare += total
        this.totalFare += total
        ancillaries.splice(idx, 1, ancillary)
      } else {
        const total = product.detail.price * product.detail.count
        product.detail.passengerPrices = [
          {
            totalFare: total,
            currency: 'CNY',
            count: product.detail.count
          }
        ]
        this.totalFare += total
        ancillaries.push(product)
      }
      flights[index][type === 'coupon' ? 'couponCartItems' : 'ancillaryCartItems'] = ancillaries
    },
    // 删除支持辅营产品及优惠券
    // product = { offerItemType: '', detail: { "offerItemId": "111112", "productCode": "YXRS", "productName": "鱼香肉丝饭", "price": 30, "count": 1 } }
    // cart = { offerItemType: 'COUPON', detail: { productName: '优惠券', price: -'', count: 1, couponType: '', couponNumber: '' } }
    remove (product, index, type = 'ancillary') {
      const { flights } = this
      const { offerItemId, price, count, couponNumber } = product.detail

      if ((!offerItemId && !couponNumber) || !count) {
        return
      }

      const ancillaries = type === 'coupon'
        ? (flights[index].couponCartItems || [])
        : (flights[index].ancillaryCartItems || [])
      const idx = type === 'coupon'
        ? (findIndex(ancillaries, item => item.detail.couponType === product.detail.couponType))
        : (findIndex(ancillaries, item => item.detail.offerItemId === offerItemId))
      if (idx > -1) {
        const ancillary = ancillaries[idx]

        if (ancillary.detail.passengerPrices[0].count <= count) {
          // remove
          this.totalFare -= ancillary.detail.passengerPrices[0].totalFare
          ancillaries.splice(idx, 1)
        } else {
          const detail = ancillary.detail.passengerPrices[0]
          const total = count * price
          detail.count -= count
          detail.totalFare -= total
          this.totalFare -= total
          ancillaries.splice(idx, 1, ancillary)
        }
      }
    },
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          const { refundChangeRuleTip } = res
          this.cmsData = {
            refundChangeRuleTips: refundChangeRuleTip?.content || ''
          }
        })
      } catch (err) {}
    }
  },
  components: {
    ChangeRule,
    ItineraryDetail,
    ItineraryTotal
  }
}
</script>
